
import { ref, onMounted, inject, shallowRef, reactive } from "vue";
import { Dialog, Toast } from 'vant'
import { useRoute } from "vue-router";
import $http  from '@/plugins/http'
export default {
  setup(props: object, ctx: any) {
      const second = ref(15)
      const countTime: any = ref(null)
      const submitDisabled = ref(true)
      const policiesChecked = ref(false)
      const $route:any = useRoute()
      // const systype = ref('')
      
      const systypeType = ref('')
      const fromToken = ref('')
      const reason = ref('Select the reason')
      const reasonText = ref(false)
      const selectReasonShow = ref(false)
      const cancellationReason = ref(null)
      const reasonList = [
        {
          key: 1,
          label: 'I am not using this account anymore'
        },
        {
          key: 2,
          label: 'I have another account'
        },
        {
          key: 3,
          label: 'I wish to create a new account'
        },
        {
          key: 4,
          label: 'I am concerned about my account security and/or unauthorized activity'
        },
        {
          key: 5,
          label: 'I have unresolved issues with Kilimall'
        },
        {
          key: 6,
          label: 'I had bad shopping experience'
        },
        {
          key: 7,
          label: 'My privacy is not well handled'
        },
        {
          key: 8,
          label: 'I don’t want to disclose my reason(s)'
        }
      ]

      // 选择原因
      const handleReasonClick = () => {
        selectReasonShow.value = true
      }

      const cancellationReasonClick = (item: any) => {
        cancellationReason.value = item.key
        selectReasonShow.value = false
        reason.value = item.label
        reasonText.value = true
      }

      // 提交注销申请
      const submitApplicationClick = () => {
        if (!cancellationReason.value) {
          Toast({message: "Please select reason"})
          return
        }
        if (!policiesChecked.value) {
          Toast({message: "You need to tick agree to Term & Condition to submit"})
          return
        }
        Dialog.confirm({
          message: 'Are you sure you want to leave? we can do better and hope to see you soon',
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Cancel',
          className: 'dialog-box'
        })
          .then(() => {
            // on confirm
            submitApplication()
          })
          .catch(() => {
            // on cancel
          });
      }

      const submitApplication = async() => {
        const params = {
          cancellationReason: cancellationReason.value,
        }
        if (systypeType.value === 'lite') {
          try {
            const res = await $http.accountApplicationLite(params, {'pfx-accesstoken': fromToken.value})
            if (res.code == 0) {
              ctx.emit('currentPage', 3)
            } else {
              Toast({message: res.msg})
            }
          } catch (e) {
            console.error(e)
          }
        } else {
          try {
            const res = await $http.accountApplication(params, { 'authorization': 'Bearer ' + fromToken.value })
            if (res.code == 200) {
              ctx.emit('currentPage', 3)
            } else {
              Toast({message: res.error})
            }
          } catch (e) {
            console.error(e)
          }
        }
        
      }

      // 倒计时
      const countDown = () => {
        const interval = setInterval(() => {
          if (second.value < 0) {
            clearInterval(interval)
            submitDisabled.value = false
          } 
          countTime.value = second.value
          second.value -= 1
        }, 1000)
      }

      onMounted(() => {
        countDown()
        const { token, systype } = $route.query
        systypeType.value = systype
        fromToken.value = token
      })

      return {
        reason,
        systypeType,
        countTime,
        reasonList,
        reasonText,
        submitDisabled,
        policiesChecked,
        selectReasonShow,
        cancellationReason,
        countDown,
        submitApplication,
        handleReasonClick,
        cancellationReasonClick,
        submitApplicationClick
      };
    },
  };
